export default function SectionHeading({ number, overline, title, subtitle, align = "left", className = "" }) {
  const center = align === "center";
  return (
    <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-3xl"} ${className}`}>
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        {number && (
          <span className="font-oswald text-sm font-bold tracking-[0.25em] text-gold">{number}</span>
        )}
        {overline && (
          <span
            data-testid="section-overline"
            className="kicker inline-flex items-center gap-3 text-[11px] text-neutral-400"
          >
            <span className="h-px w-8 bg-gold/70" />
            {overline}
          </span>
        )}
      </div>
      <h2 className="mt-5 font-display text-[1.9rem] font-semibold leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-[2.85rem]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base font-light leading-relaxed text-neutral-400 sm:text-lg">{subtitle}</p>
      )}
    </div>
  );
}
